var _mask, _g, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniLavanderiaResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "1cpggdrfla",
    width: 19,
    height: 14,
    x: 11,
    y: 17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.083 17.99H29.45V31H11.083V17.99z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1cpggdrfla)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M20.266 28.322c-2.113 0-3.826-1.713-3.826-3.827 0-2.112 1.713-3.826 3.826-3.826s3.827 1.714 3.827 3.826c0 2.114-1.714 3.827-3.827 3.827zM11.083 17.99v10.33c0 1.48 1.2 2.68 2.679 2.68H26.77c1.48 0 2.679-1.2 2.679-2.68v-10.33H11.083z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "uybh6sthbb",
    width: 19,
    height: 7,
    x: 11,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 9h18.365v6.887H11V9z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#uybh6sthbb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M25.707 13.209H21.88c-.422 0-.766-.344-.766-.766 0-.422.343-.764.766-.764h3.827c.422 0 .764.342.764.764s-.342.766-.764.766zm-8.417 0h-1.914c-.423 0-.765-.344-.765-.766 0-.422.342-.764.765-.764h1.914c.42 0 .764.342.764.764s-.343.766-.764.766zM26.687 9H13.678C12.2 9 11 10.199 11 11.678v4.21h18.365v-4.21c0-1.479-1.2-2.678-2.678-2.678z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniLavanderiaResting);
export default __webpack_public_path__ + "static/media/icon_mini_lavanderia_resting.eae29b08928dbbb89b178bce4ead45fe.svg";
export { ForwardRef as ReactComponent };